import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {Status} from "../../../common/constants";
import { listAlertusTokensUrl } from "../../../config"
import api from '../../../api';

export interface IAlertusToken {
  entryId: string;
  userEmail: string;
  tokenName: string;
  issuedAt: string;   
  expiresAt: number | "never" | null;
}

interface IAlertusTokensState {
  tokens: any;
  status: string;
  error: string | null;
  dataFetched: boolean;
}

const initialState: IAlertusTokensState = {
  tokens: {},
  status: Status.IDLE,
  error: null,
  dataFetched: false,
};

export const listAlertusTokens: any = createAsyncThunk(
  'listAlertusTokens',
  async () => {
    try {
      const response = await api.get(listAlertusTokensUrl);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

// Create slice
const listAlertusTokensSlice = createSlice({
  name: 'listAlertusTokens',
  initialState,
  reducers: {
    setDataFetched: (state, action) => {
      state.dataFetched = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listAlertusTokens.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(listAlertusTokens.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.tokens = action.payload;
      })
      .addCase(listAlertusTokens.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message ?? null;
      });
  },
});

type Selector = {
  listAlertusTokens: ReturnType<typeof listAlertusTokensSlice.reducer>;
};

export const selector = (store: Selector) => store['listAlertusTokens'];

export default listAlertusTokensSlice.reducer;
export const { setDataFetched } = listAlertusTokensSlice.actions;
